export interface IRecommendationContact {
  name: string;
  phone: string;
  realtyUserId: number;
  type: EContactType;
}

export enum EContactType {
  Builder = 'builder',
  Seller = 'seller',
}
